import Api from "../../utils/axios";

export const FundingApi = {
    createFund: (payload) => Api.post("admin/create-finance-and-funding",payload,{headers:{"Content-Type":"multipart/form-data"}}),
    updateFund: (payload, id) => Api.put(`admin/update-finance-and-funding/${id}`,payload,{headers:{"Content-Type":"multipart/form-data"}}),
    // getFundById: (id) => Api.get(`/admin/update-course/${id}`),
    getAllFund: () => Api.post(`admin/get-all-finance-and-funding`),
    deleteFund: (id) => Api.delete(`admin/delete-finance-and-funding/${id}`)
};